function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-1.136-6.72v-.736c0-1.768.793-2.367 1.52-2.916.616-.465 1.184-.893 1.184-1.964 0-1.104-.608-1.712-1.792-1.712-1.184 0-1.84.608-1.84 2.08h-1.28C8.64 7.728 9.792 6.72 11.776 6.72c1.984 0 3.12 1.008 3.12 2.944 0 1.533-.73 2.098-1.438 2.646-.667.516-1.314 1.018-1.314 2.298v.672h-1.28zm1.456 1.968c0 .544-.368.832-.8.832-.448 0-.816-.288-.816-.832 0-.512.368-.8.816-.8.432 0 .8.288.8.8z",
  fill: "currentColor"
});

function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSupport;